import { render, staticRenderFns, recyclableRender, components } from "./balance-details.vue?vue&type=template&id=838fd8ac&scoped=true&"
var renderjs
import script from "./balance-details.vue?vue&type=script&lang=js&"
export * from "./balance-details.vue?vue&type=script&lang=js&"
import style0 from "./balance-details.vue?vue&type=style&index=0&id=838fd8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838fd8ac",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/balance-details/balance-details.vue"
export default component.exports